<script lang="ts">
	import { devices } from '../../../../stores';
	import { resolveDeviceInStore } from '../../helpers/resolveDeviceInStore';
	import { getEffectiveNodeDisplayLabel } from '../../PropertyEditors/helpers/LabelGenerator';
	import BaseConditionNode from '../BaseConditionNode.svelte';
	import type { FlowNode, NodeData } from '../../types/flow-types';
	import { isDeviceCheckSingleOutput } from '../../helpers/deviceCheckMode';
	import ConditionSentence from './ConditionSentence.svelte';

	export let id: string;
	export let data: NodeData;
	export let selected: boolean = false;
	export let validated: boolean = true;
	export let errors: string[] = [];

	$: dc = data._device_condition as any;
	$: cap = data.sceneCapability as any;
	$: deviceId = data.device?.id ?? dc?.device?.id ?? cap?.deviceId ?? (data.device as any)?.id;
	$: deviceChannel =
		parseInt(
			String(dc?.device?.channel ?? cap?.channel ?? (data.device as any)?.channel ?? '0'),
			10,
		) || 0;
	$: deviceName = (() => {
		$devices;
		const resolved = deviceId ? resolveDeviceInStore($devices, deviceId, deviceChannel)?.name : '';
		return resolved || data.device_name || (data.device as any)?.name || deviceId || '';
	})();
	$: condName =
		data.cond_name ||
		(data.property as any)?.id ||
		dc?.cond_name ||
		cap?.capabilityName ||
		cap?.name ||
		'';
	$: displayText = (() => {
		$devices;
		return getEffectiveNodeDisplayLabel({
			id,
			type: 'condition',
			position: { x: 0, y: 0 },
			data,
			validated,
			errors,
		} as FlowNode);
	})();
	$: hasTriggerInput = data.hasTriggerInput || false;
	$: hideFalseOutput = isDeviceCheckSingleOutput({
		id,
		type: 'condition',
		position: { x: 0, y: 0 },
		data,
		validated,
		errors,
	} as FlowNode);
	$: labelList = hasTriggerInput
		? [{ icon: 'fas fa-bolt', value: 'Triggered', iconColor: 'warning' as const }]
		: undefined;
</script>

<BaseConditionNode
	{id}
	type="condition"
	{data}
	{selected}
	{validated}
	{errors}
	{hideFalseOutput}
	{...$$restProps}
	cardTitle={deviceName || displayText}
	{labelList}
>
	{#if deviceName && condName}
		<div class="body">
			<ConditionSentence label={displayText} {deviceName} />
		</div>
	{:else}
		<div class="body fallback">{displayText}</div>
	{/if}
</BaseConditionNode>

<style>
	.body {
		font-size: 0.8125rem;
		line-height: 1.4;
	}

	.fallback {
		color: var(--flow-slot-strong, #111827);
		font-weight: 500;
	}
</style>
